module.exports = __webpack_public_path__ + "0d7240bb30bcb5296ba4a3a9d2269d42.png";